/* Product page gallery: snippets/product-gallery.liquid.
   Scroll-snap carousel (thumbnails, arrows, dots, counter, keyboard), grid layouts on desktop,
   selected variant's image first, hover magnifier and a full-screen lightbox. */
(function () {
  'use strict';
  var MOBILE = window.matchMedia('(max-width: 819px)');
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var hasInert = typeof HTMLElement !== 'undefined' && 'inert' in HTMLElement.prototype;

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function esc(v) { return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function a11y() { return (window.BO && window.BO.a11y) || null; }

  function setup(gal) {
    if (gal.dataset.galReady) return;
    gal.dataset.galReady = '1';
    var layout = gal.dataset.layout || 'thumbs_left';
    var isGridLayout = layout === 'grid' || layout === 'grid_hero' || layout === 'stacked';
    var track = $('[data-gal-track]', gal);
    var thumbsBox = $('[data-gal-thumbs]', gal);
    var prev = $('[data-gal-prev]', gal), next = $('[data-gal-next]', gal);
    var cur = $('[data-gal-current]', gal);
    var pg = gal.closest('[data-product-page]');
    var active = 0, raf = null;
    if (!track) return;

    function slides() { return $$('[data-gal-slide]', track); }
    function thumbs() { return $$('[data-gal-thumb]', gal); }
    function dots() { return $$('[data-gal-dot]', gal); }
    // Grid layouts only behave as a carousel on mobile
    function sliding() { return !isGridLayout || MOBILE.matches; }

    function slideLeft(s) { return s.offsetLeft; }

    function mark(i) {
      var list = slides();
      if (!list.length) return;
      active = Math.max(0, Math.min(i, list.length - 1));
      var slide = sliding();
      list.forEach(function (s, k) {
        var on = k === active;
        s.classList.toggle('is-active', on);
        // Off-screen carousel slides stay out of the Tab order; every grid tile is reachable
        if (hasInert) s.inert = slide && !on;
        if (!on) $$('video', s).forEach(function (v) { if (!v.paused) v.pause(); });
      });
      thumbs().forEach(function (t, k) {
        var on = k === active;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-current', on ? 'true' : 'false');
        if (on && thumbsBox && thumbsBox.scrollHeight + thumbsBox.scrollWidth > thumbsBox.clientHeight + thumbsBox.clientWidth) {
          var vertical = thumbsBox.scrollHeight > thumbsBox.clientHeight + 2;
          if (vertical) thumbsBox.scrollTo({ top: t.offsetTop - thumbsBox.clientHeight / 2 + t.offsetHeight / 2, behavior: reduceMotion ? 'auto' : 'smooth' });
          else thumbsBox.scrollTo({ left: t.offsetLeft - thumbsBox.clientWidth / 2 + t.offsetWidth / 2, behavior: reduceMotion ? 'auto' : 'smooth' });
        }
      });
      dots().forEach(function (d, k) { d.classList.toggle('is-active', k === active); d.setAttribute('aria-current', k === active ? 'true' : 'false'); });
      if (cur) cur.textContent = active + 1;
      if (prev) prev.disabled = active === 0;
      if (next) next.disabled = active === list.length - 1;
    }

    function go(i, instant) {
      var list = slides();
      if (!list.length) return;
      i = Math.max(0, Math.min(i, list.length - 1));
      showPhotos();
      if (sliding()) {
        track.scrollTo({ left: slideLeft(list[i]), behavior: instant ? 'instant' : (reduceMotion ? 'auto' : 'smooth') });
      } else {
        var top = list[i].getBoundingClientRect().top + window.scrollY - (parseInt(getComputedStyle(gal).getPropertyValue('--gal-top'), 10) || 96);
        window.scrollTo({ top: top, behavior: reduceMotion ? 'auto' : 'smooth' });
      }
      mark(i);
    }

    // Thumbnail/dot clicks switch back from the 360 or film view
    function showPhotos() {
      var tab = pg && $('[data-view-tab="photo"]', pg);
      if (tab && tab.getAttribute('aria-selected') !== 'true') tab.click();
    }

    track.addEventListener('scroll', function () {
      if (!sliding() || raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        var w = track.clientWidth || 1;
        var i = Math.round(Math.abs(track.scrollLeft) / w);
        if (i !== active) mark(i);
      });
    }, { passive: true });

    if (prev) prev.addEventListener('click', function () { go(active - 1); });
    if (next) next.addEventListener('click', function () { go(active + 1); });
    gal.addEventListener('click', function (e) {
      var t = e.target.closest('[data-gal-thumb], [data-gal-dot]');
      if (t && gal.contains(t)) { go(parseInt(t.dataset.galThumb || t.dataset.galDot, 10)); return; }
      var o = e.target.closest('[data-gal-open]');
      if (o) { openLightbox(gal, parseInt(o.dataset.galOpen, 10), o); return; }
      if (gal.hasAttribute('data-lightbox')) {
        var m = e.target.closest('.bo-gal__slide--image .bo-gal__media');
        if (m) { var s = m.closest('[data-gal-slide]'); openLightbox(gal, parseInt(s.dataset.galSlide, 10), $('[data-gal-open]', s)); }
      }
    });
    track.addEventListener('keydown', function (e) {
      if (!sliding()) return;
      if (e.key === 'ArrowRight') { e.preventDefault(); go(active + 1); var s = slides()[active]; var f = s && $('button, a, [tabindex]', s); if (f) f.focus({ preventScroll: true }); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(active - 1); var s2 = slides()[active]; var f2 = s2 && $('button, a, [tabindex]', s2); if (f2) f2.focus({ preventScroll: true }); }
    });
    if (thumbsBox) thumbsBox.addEventListener('keydown', function (e) {
      var list = thumbs(), i = list.indexOf(document.activeElement);
      if (i < 0) return;
      var n = null;
      if (e.key === 'ArrowDown' || e.key === 'ArrowRight') n = Math.min(i + 1, list.length - 1);
      if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') n = Math.max(i - 1, 0);
      if (n === null) return;
      e.preventDefault(); list[n].focus(); go(n);
    });

    // Hover magnifier
    if (canHover) $$('[data-gal-zoom]', track).forEach(function (m) {
      var img = $('img', m); if (!img) return;
      m.addEventListener('mousemove', function (e) {
        var r = m.getBoundingClientRect();
        img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
        img.style.transform = 'scale(1.6)';
      });
      m.addEventListener('mouseleave', function () { img.style.transform = ''; });
    });

    // Variant change: theme.js updates the hidden id input and fires "change"
    var data = null;
    try { data = JSON.parse($('[data-product-json]', pg).textContent); } catch (e) { data = null; }
    if (pg && data) pg.addEventListener('change', function (e) {
      if (!e.target.matches || !e.target.matches('[data-variant-id]')) return;
      var v = data.variants.filter(function (x) { return String(x.id) === String(e.target.value); })[0];
      if (!v || !v.media) return;
      var list = slides(), idx = -1;
      list.forEach(function (s, k) { if (s.dataset.mediaId === String(v.media)) idx = k; });
      if (idx < 0) return;
      if (isGridLayout) {
        // Grid layouts: the variant's image moves to the front, like the initial page load
        if (idx > 0) {
          track.insertBefore(list[idx], track.firstChild);
          var th = thumbs()[idx]; if (th && thumbsBox) thumbsBox.insertBefore(th, thumbsBox.firstChild);
          renumber();
        }
        if (sliding()) track.scrollTo({ left: 0, behavior: 'instant' });
        mark(0);
      } else {
        go(idx);
      }
    });

    function renumber() {
      slides().forEach(function (s, k) { s.dataset.galSlide = k; var o = $('[data-gal-open]', s); if (o) { o.dataset.galOpen = k; } });
      thumbs().forEach(function (t, k) { t.dataset.galThumb = k; });
      var tpl = gal.dataset.labelTpl;
      if (tpl) {
        thumbs().forEach(function (t, k) { t.setAttribute('aria-label', tpl.replace('[n]', k + 1)); });
        slides().forEach(function (s, k) { var o = $('[data-gal-open]', s); if (o) o.setAttribute('aria-label', tpl.replace('[n]', k + 1)); });
      }
    }

    // Used by the lightbox to leave the page gallery on the image last viewed there
    gal._galGo = function (i) { if (sliding()) { var s = slides()[i]; if (s) track.scrollTo({ left: slideLeft(s), behavior: 'instant' }); } mark(i); };

    function onMode() { mark(active); var s = slides()[active]; if (sliding() && s) track.scrollTo({ left: slideLeft(s), behavior: 'instant' }); }
    if (MOBILE.addEventListener) MOBILE.addEventListener('change', onMode); else if (MOBILE.addListener) MOBILE.addListener(onMode);
    window.addEventListener('resize', function () { if (sliding()) { var s = slides()[active]; if (s) track.scrollTo({ left: slideLeft(s), behavior: 'instant' }); } });
    mark(0);
  }

  /* ---------------- Lightbox ---------------- */
  var lb = null, lbState = { gal: null, opener: null, i: 0 };
  function buildLightbox() {
    lb = document.createElement('div');
    lb.className = 'bo-gal-lb';
    lb.hidden = true;
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.innerHTML =
      '<div class="bo-gal-lb__bar"><span class="bo-gal-lb__count bo-mono" aria-hidden="true"></span>' +
      '<button type="button" class="bo-gal-lb__btn" data-lb-close><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div>' +
      '<div class="bo-gal-lb__nav"><button type="button" class="bo-gal-lb__btn" data-lb-prev><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true" focusable="false"><path d="M15 5l-7 7 7 7"/></svg></button>' +
      '<button type="button" class="bo-gal-lb__btn" data-lb-next><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true" focusable="false"><path d="M9 5l7 7-7 7"/></svg></button></div>' +
      '<div class="bo-gal-lb__track" data-lb-track></div>';
    document.body.appendChild(lb);
    var tr = $('[data-lb-track]', lb), raf = null;
    $('[data-lb-close]', lb).addEventListener('click', closeLightbox);
    $('[data-lb-prev]', lb).addEventListener('click', function () { lbGo(lbState.i - 1); });
    $('[data-lb-next]', lb).addEventListener('click', function () { lbGo(lbState.i + 1); });
    tr.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = null; var i = Math.round(Math.abs(tr.scrollLeft) / (tr.clientWidth || 1)); if (i !== lbState.i) lbMark(i); });
    }, { passive: true });
    tr.addEventListener('click', function (e) {
      var img = e.target.closest('img'); if (!img) return;
      var fig = img.parentElement, r = img.getBoundingClientRect();
      if (!fig.classList.contains('is-zoomed')) img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
      fig.classList.toggle('is-zoomed');
    });
    tr.addEventListener('mousemove', function (e) {
      var fig = e.target.closest('.bo-gal-lb__fig.is-zoomed'); if (!fig) return;
      var img = $('img', fig), r = fig.getBoundingClientRect();
      img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
    });
    lb.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); lbGo(lbState.i + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); lbGo(lbState.i - 1); }
    });
  }
  function lbFigs() { return $$('.bo-gal-lb__fig', lb); }
  function lbMark(i) {
    var figs = lbFigs();
    lbState.i = Math.max(0, Math.min(i, figs.length - 1));
    figs.forEach(function (f, k) { if (k !== lbState.i) f.classList.remove('is-zoomed'); if (hasInert) f.inert = k !== lbState.i; });
    $('.bo-gal-lb__count', lb).textContent = (lbState.i + 1) + ' / ' + figs.length;
    $('[data-lb-prev]', lb).disabled = lbState.i === 0;
    $('[data-lb-next]', lb).disabled = lbState.i === figs.length - 1;
  }
  function lbGo(i, instant) {
    var figs = lbFigs(); if (!figs.length) return;
    i = Math.max(0, Math.min(i, figs.length - 1));
    var tr = $('[data-lb-track]', lb);
    tr.scrollTo({ left: figs[i].offsetLeft, behavior: instant ? 'instant' : (reduceMotion ? 'auto' : 'smooth') });
    lbMark(i);
  }
  function openLightbox(gal, slideIndex, opener) {
    if (!lb) buildLightbox();
    var imgs = $$('[data-gal-slide][data-full]', gal);
    if (!imgs.length) return;
    var start = 0;
    imgs.forEach(function (s, k) { if (parseInt(s.dataset.galSlide, 10) === slideIndex) start = k; });
    var tr = $('[data-lb-track]', lb);
    tr.innerHTML = imgs.map(function (s) {
      var full = s.dataset.full, base = full.replace(/([?&])width=\d+/, '$1');
      var sep = base.indexOf('?') > -1 ? (/[?&]$/.test(base) ? '' : '&') : '?';
      var srcset = /[?&]width=\d+/.test(full) ? ' srcset="' + [1200, 1800, 2400].map(function (w) { return base + sep + 'width=' + w + ' ' + w + 'w'; }).join(', ') + '" sizes="100vw"' : '';
      return '<figure class="bo-gal-lb__fig"><img src="' + esc(full) + '"' + srcset + ' alt="' + esc(s.dataset.alt) + '" loading="lazy" draggable="false"></figure>';
    }).join('');
    var S = (window.BO && window.BO.strings) || {};
    lb.setAttribute('aria-label', gal.dataset.lbLabel || 'Product images');
    $('[data-lb-close]', lb).setAttribute('aria-label', gal.dataset.lbClose || S.close || 'Close');
    $('[data-lb-prev]', lb).setAttribute('aria-label', gal.dataset.lbPrev || 'Previous image');
    $('[data-lb-next]', lb).setAttribute('aria-label', gal.dataset.lbNext || 'Next image');
    lbState.gal = gal; lbState.opener = opener || document.activeElement;
    lb.hidden = false;
    document.body.classList.add('bo-locked');
    requestAnimationFrame(function () { lbGo(start, true); });
    var A = a11y();
    if (A) A.openDialog(lb, { opener: lbState.opener, close: closeLightbox, focus: function () { return $('[data-lb-close]', lb); } });
    else $('[data-lb-close]', lb).focus();
  }
  function closeLightbox() {
    if (!lb || lb.hidden) return;
    var gal = lbState.gal, focusTo = lbState.opener;
    // Keep the page gallery on the image last viewed in the lightbox, and return focus there
    if (gal && gal._galGo) {
      var s = $$('[data-gal-slide][data-full]', gal)[lbState.i];
      if (s) {
        gal._galGo(parseInt(s.dataset.galSlide, 10));
        focusTo = $('[data-gal-open]', s) || focusTo;
      }
    }
    lb.hidden = true;
    document.body.classList.remove('bo-locked');
    var A = a11y();
    if (A) A.closeDialog(lb, { returnFocus: false });
    if (focusTo && focusTo.focus) { try { focusTo.focus({ preventScroll: true }); } catch (e) { focusTo.focus(); } }
  }

  function init(root) { $$('[data-gallery]', root).forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
